import Image from "next/image";
import { COLLECTION_DESCRIPTION } from "./Banner";
import {
  EyeSlashIcon,
  HandThumbUpIcon,
  ShieldCheckIcon,
  UserGroupIcon,
} from "@heroicons/react/24/solid";

const features = [
  {
    name: "Privacidad.",
    description:
      "Asesoría que respeta su privacidad. Nos encargamos de las conversaciones y citas con posibles compradores. La discreción es la clave de la exclusividad.",
    icon: EyeSlashIcon,
  },
  {
    name: "Seguridad.",
    description:
      "Filtramos a los clientes y nos aseguramos que las personas interesadas sean personas serias y confiables. Su inversión protegida con precisión.",
    icon: ShieldCheckIcon,
  },
  {
    name: "Experiencia.",
    description:
      "Contamos con más de 15 años de experiencia y un network de proveedores de servicios como notariado (traspasos), financiamiento, seguros, carrocería y pintura, detailing, entre otros.",
    icon: UserGroupIcon,
  },
  {
    name: "Confianza.",
    description:
      "Nos enfocamos en construir confianza a través de relaciones duraderas.",
    icon: HandThumbUpIcon,
  },
];

export default function CollectionFeatures() {
  return (
    <div className="overflow-hidden bg-white py-4">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h1 className="text-base font-semibold leading-7 text-orange-500">
                Te presentamos Collection by Movi
              </h1>
              {/* <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                A better workflow
              </p> */}
              <div className="mt-2">
                <Image
                  src="/collection_transparent_bg.png"
                  alt="Logo Movi Collection"
                  width={220}
                  height={61.6}
                />
              </div>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                {COLLECTION_DESCRIPTION}
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        className="absolute left-1 top-1 h-5 w-5 text-orange-500"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src="/collection_cover.jpg"
            alt="Collection by Movi cover"
            className="w-full max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 md:-ml-4 lg:-ml-0"
            width={1920}
            height={2880}
          />
        </div>
      </div>
    </div>
  );
}
